import React from 'react';

const EmptySpan = () => <span></span>;

export default EmptySpan;
